import Head from 'next/head'
import shopInfos from 'template/infos'
import config from 'src/config'
const { name, url } = shopInfos
const germanyOnly = config.deliveryCountries.length === 1 && config.deliveryCountries[0] === 'DE'

const Seo: React.FC = () => <Head>

  <title>{germanyOnly ? `Lieferung innerhalb Deutschlands bei ${name}` : `Internationale Lieferungen bei ${name}`}</title>

  <meta name='description' content={germanyOnly
    ? `Bei ${name} liefern wir ausschließlich innerhalb Deutschlands.`
    : `Auslandsversand und internationale Lieferungen sind bei ${name} kein Problem. Auf dieser Seite finden Sie die entsprechenden Konditionen und Preise.`
  } />

  <link rel='canonical' href={`${url}auslandsversandkosten`} />

</Head>

export default Seo
